export default __webpack_public_path__ + "static/media/feature_1@3x.f9975701.png";